var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6673 2.00033H12.334C13.0673 2.00033 13.6673 2.60033 13.6673 3.33366V14.0003C13.6673 14.7337 13.0673 15.3337 12.334 15.3337H1.66732C0.933984 15.3337 0.333984 14.7337 0.333984 14.0003V3.33366C0.333984 2.60033 0.933984 2.00033 1.66732 2.00033H2.33398V0.666992H3.66732V2.00033H10.334V0.666992H11.6673V2.00033ZM1.66732 14.0003H12.334V5.33366H1.66732V14.0003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.d2a78abc53addcbe10207ed13ba68964.svg";
export { ForwardRef as ReactComponent };